import { render, staticRenderFns } from "./AddCNIC.vue?vue&type=template&id=997b8cca"
import script from "./AddCNIC.vue?vue&type=script&lang=js"
export * from "./AddCNIC.vue?vue&type=script&lang=js"
import style0 from "./AddCNIC.vue?vue&type=style&index=0&id=997b8cca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports